"use client";

import { Star } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VoicesOfTheTribe() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const testimonials = [{
    telegram: "REPORT N° 047 · SUMMER CAMP · 2024",
    quote: "Youth Tribe has been a total game changer for my teen. The summer camp was packed with energy, and they came home with so much confidence.",
    author: "SARAH J.",
    position: "PROUD PARENT",
    rotation: "-rotate-1",
    mobileRotation: "md:-rotate-1"
  }, {
    telegram: "REPORT N° 082 · FRIDAY NIGHTS · 2024",
    quote: "The Friday night social events are the highlight of our week. It's a safe, high-energy space where everyone feels like they belong.",
    author: "MARCUS T.",
    position: "TRIBE MEMBER",
    rotation: "rotate-[1.5deg]",
    mobileRotation: "md:rotate-[1.5deg]"
  }, {
    telegram: "REPORT N° 119 · COMMUNITY · 2024",
    quote: "From the live music nights to the volunteer projects, Youth Tribe is more than a group—it's a family that pushes you to be your best.",
    author: "ELENA R.",
    position: "VOLUNTEER LEADER",
    rotation: "rotate-[0.5deg]",
    mobileRotation: "md:rotate-[0.5deg]"
  }];
  return <section data-section-id="1447" id="voices-of-the-tribe" ref={ref} className="relative bg-primary text-primary-foreground py-28 md:py-40 overflow-hidden border-t-2" style={{
    borderTopColor: "var(--secondary)"
  }}>
      {}
      <div className="absolute top-6 left-6 md:top-10 md:left-10 font-mono text-[0.6875rem] tracking-[0.22em] text-primary-foreground/60 hidden md:block">
        <div className="flex items-start gap-2">
          <div className="flex flex-col gap-1">
            <span className="block w-3 h-px bg-primary-foreground/60" />
            <span className="block w-px h-3 bg-primary-foreground/60" />
          </div>
          <span>TRIBE · HQ · 2024</span>
        </div>
      </div>
      <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 font-mono text-[0.6875rem] tracking-[0.22em] text-primary-foreground/60 hidden md:block">
        <div className="flex items-end gap-2">
          <span>ARCHIVE · VOL IV</span>
          <div className="flex flex-col gap-1">
            <span className="block w-px h-3 bg-primary-foreground/60 ml-auto" />
            <span className="block w-3 h-px bg-primary-foreground/60" />
          </div>
        </div>
      </div>

      <div className="container max-w-[1320px] mx-auto px-6 md:px-10 lg:px-16">
        {}
        <div className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          {}
          <div className="lg:col-span-7">
            <div className="font-mono text-[0.6875rem] md:text-[0.8125rem] tracking-[0.22em] uppercase mb-6 flex items-center gap-3">
              
              <span className="block w-8 h-px" style={{
              backgroundColor: "var(--secondary)"
            }} />
              <span className="text-primary-foreground/80">FEEDBACK</span>
            </div>
            <h2 className="font-default font-bold text-primary-foreground leading-[1.02]" style={{
            fontSize: "clamp(2.25rem, 4.4vw, 4.25rem)",
            letterSpacing: "-0.018em"
          }}>
              Voices of the{" "}
              <span className="relative inline-block italic">
                Tribe
                <span className={`absolute left-0 right-0 h-[2px] bottom-[-6px] origin-left transition-transform duration-700 delay-200 ease-out ${isVisible ? "scale-x-100" : "scale-x-0"}`} style={{
                backgroundColor: "var(--secondary)"
              }} />
              </span>
            </h2>
          </div>

          {}
          <div className="lg:col-span-5 flex lg:justify-end">
            <div className="flex flex-col items-start lg:items-end gap-3">
              <div className="inline-flex flex-col items-center px-7 py-5 rounded-lg -rotate-[4deg] relative" style={{
              border: "2px double var(--secondary)",
              boxShadow: "inset 0 0 0 3px transparent, inset 0 0 0 4px var(--primary)"
            }}>
                <div className="absolute inset-1 rounded-lg pointer-events-none" style={{
                border: "1px dashed hsl(42 78% 52% / 0.5)"
              }} />
                <span className="font-mono text-[0.6875rem] tracking-[0.22em] uppercase" style={{
                color: "var(--secondary)"
              }}>
                  Community Verified
                </span>
                <span className="font-default font-bold text-2xl md:text-3xl mt-1" style={{
                color: "var(--secondary)"
              }}>
                  5.0 / 5.0
                </span>
                <div className="flex gap-1 mt-2">
                  {[...Array(5)].map((_, i) => <Star key={i} data-index={i} className="w-3 h-3" style={{
                  color: "var(--secondary)",
                  fill: "var(--secondary)"
                }} />)}
                </div>
              </div>
              <span className="font-mono text-[0.6875rem] tracking-[0.22em] uppercase text-primary-foreground/70 lg:pr-4">
                Based on 200+ Member Stories
              </span>
            </div>
          </div>
        </div>

        {}
        <div className="relative flex items-center my-16 md:my-20">
          <span className="block w-[6px] h-[6px] rounded-lg" style={{
          backgroundColor: "var(--secondary)"
        }} />
          <span className="flex-1 h-px" style={{
          backgroundImage: "repeating-linear-gradient(to right, var(--secondary) 0, var(--secondary) 4px, transparent 4px, transparent 10px)"
        }} />
          <span className="block w-[6px] h-[6px] rounded-lg" style={{
          backgroundColor: "var(--secondary)"
        }} />
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {testimonials.map((t, i) => <div data-index={i} key={i} className={`group relative bg-background text-foreground rounded-lg p-8 transition-all duration-700 ease-out ${t.mobileRotation} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${300 + i * 120}ms`,
          border: "1px dashed var(--primary)"
        }}>
              {}
              <div className="absolute top-0 left-0 right-0 h-2 -translate-y-1/2 flex items-center justify-around pointer-events-none" aria-hidden="true">
                {[...Array(18)].map((_, idx) => <span key={idx} className="block w-1.5 h-1.5 rounded-lg" style={{
              backgroundColor: "var(--background)",
              border: "1px dashed var(--primary)"
            }} />)}
              </div>

              {}
              <div className="flex gap-1 mb-3">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4" style={{
              color: "var(--secondary)",
              fill: "var(--secondary)"
            }} />)}
              </div>

              {}
              <div className="font-mono text-[0.6875rem] tracking-[0.14em] uppercase mb-6 pb-4" style={{
            color: "var(--muted-foreground)",
            borderBottom: "1px dashed hsl(226 91% 39% / 0.3)"
          }}>
                {t.telegram}
              </div>

              {}
              <p className="font-default text-[1.0625rem] leading-[1.65] mb-8" style={{
            color: "var(--primary)"
          }}>
                &ldquo;{t.quote}&rdquo;
              </p>

              {}
              <div className="flex items-end justify-between gap-4 pt-2">
                <div>
                  <div className="font-mono text-xs tracking-[0.14em] uppercase font-bold" style={{
                color: "var(--foreground)"
              }}>
                    {t.author}
                  </div>
                  <div className="font-mono text-[0.6875rem] tracking-[0.14em] uppercase mt-1" style={{
                color: "var(--muted-foreground)"
              }}>
                    {t.position}
                  </div>
                </div>

                {}
                <div className="relative flex items-center justify-center w-12 h-12 rounded-lg shrink-0" style={{
              backgroundColor: "var(--primary)",
              border: "2px solid var(--secondary)"
            }} aria-hidden="true">
                  <span className="font-default font-bold text-xl" style={{
                color: "var(--secondary)"
              }}>
                    YT
                  </span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}